jQuery(document).ready(function($) {
    $('.category-toggle-btn').on('click', function() {
        var $accordion = $(this).closest('.category-accordion');
        var $content = $accordion.find('.category-content .text-opacity-70');
        var $gradient = $accordion.find('.bg-gradient-to-t');
        var $icon = $(this).find('svg');
        
        if($accordion.hasClass('expanded')) {
            // Kapat
            $accordion.removeClass('expanded').addClass('collapsed');
            $accordion.css('max-height', '200px');
            $content.removeClass('text-opacity-100').addClass('text-opacity-70');
            $gradient.removeClass('opacity-0');
            $icon.css('transform', 'rotate(0deg)');
            $(this).find('span').text('Pokaż więcej');
        } else {
            // Aç
            $accordion.removeClass('collapsed').addClass('expanded');
            $accordion.css('max-height', $accordion[0].scrollHeight + 'px');
            $content.removeClass('text-opacity-70').addClass('text-opacity-100');
            $gradient.addClass('opacity-0');
            $icon.css('transform', 'rotate(180deg)');
            $(this).find('span').text('Pokaż mniej');
        }
    });
});